import React, { useCallback, useMemo, useState } from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import {
  ToClipboardProps,
  ToClipboardState,
  ToClipboardStylesStructure,
} from '@pijma/hero-types'
import { useStyles } from '@pijma/theme-provider'
import { debounce } from '@pijma/utils'

export const ToClipboard: React.FC<ToClipboardProps> = (props) => {
  const [justCopied, setJustCopied] = useState(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const switchOffCopiedState = useCallback(
    debounce(() => setJustCopied(false), 600),
    [],
  )
  const state = useMemo<ToClipboardState>(() => ({ justCopied }), [justCopied])

  const handleClick = async () => {
    await navigator.clipboard.writeText(props.text)

    setJustCopied(true)
    switchOffCopiedState()
  }

  const {
    classNames: { iconWrapper, root, label, buttonWrapper, textWrapper },
    components: { Icon },
  } = useStyles<ToClipboardStylesStructure>(['ToClipboard'], {
    ...props,
    ...state,
  })

  return (
    <PijmaComponent as="div" commonProps={props} className={root}>
      <span className={textWrapper}>
        {!props.standalone && (props.children || props.text)}
      </span>

      <div className={buttonWrapper}>
        <button onClick={handleClick} className={iconWrapper}>
          {Icon}
          {props.label && <span className={label}>{props.label}</span>}
        </button>
      </div>
    </PijmaComponent>
  )
}
